import { useContext } from "react";
import { AvailabilityContext } from "../providers/AvailabilityProvider";

export default function useAvailability() {
  const availabilityContext = useContext(AvailabilityContext);

  return availabilityContext;
}
